import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageTransition } from '@/components/motion';
import BrokerSettingsModal from '@/components/Apollo/BrokerSettingsModal';
import { brokersAPI } from '@/services/apolloApi';

function NewBroker() {
  const navigate = useNavigate();
  const [open] = useState(true);

  async function handleSave(data) {
    const broker = await brokersAPI.create(data);
    navigate(`/apollo/brokers/${broker.id}`);
  }

  return (
    <PageTransition className="p-6 max-w-2xl mx-auto">
      <button
        onClick={() => navigate('/apollo/brokers')}
        className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Brokers
      </button>

      <BrokerSettingsModal
        open={open}
        onClose={() => navigate('/apollo/brokers')}
        onSave={handleSave}
      />
    </PageTransition>
  );
}

export default NewBroker;
